module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_8011.0ef7531f.png";